import { render } from "./BuildingPartControl.vue?vue&type=template&id=22a200ac&ts=true"
import script from "./BuildingPartControl.vue?vue&type=script&lang=ts"
export * from "./BuildingPartControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__